// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Thumbnail__title, .Thumbnail {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */ /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}

.Thumbnail {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}
.Thumbnail__title {
  position: absolute;
  opacity: 0;
  transition: 300ms;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  padding: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
}
.Thumbnail:hover .Thumbnail__title {
  opacity: 1;
  transition: 300ms;
}
.Thumbnail__content {
  flex-grow: 2;
  width: 100%;
}
.Thumbnail__toolbar {
  position: relative;
  bottom: 0;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/AssetLibrary/AssetThumbnail/AssetThumbnail.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,WAAA,EACA,mBAAA;EACA,sBAAA,EAAA,4BAAA,EACA,2BAAA;EACA,iBAAA,EAAA,2EAAA;AACJ;;AAEA;EAGI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AADJ;AAGI;EAGI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAHR;AAMI;EACI,UAAA;EACA,iBAAA;AAJR;AAOI;EACI,YAAA;EACA,WAAA;AALR;AAQI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AANR","sourcesContent":["%disable-text-selection {\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */\n}\n\n.Thumbnail {\n    @extend %disable-text-selection;\n\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    align-items: center;\n\n    &__title {\n        @extend %disable-text-selection;\n\n        position: absolute;\n        opacity: 0;\n        transition: 300ms;\n        color: white;\n        background: rgba(0, 0, 0, 0.5);\n        padding: 15px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        width: 100%;\n        text-align: center;\n    }\n\n    &:hover &__title {\n        opacity: 1;\n        transition: 300ms;\n    }\n\n    &__content {\n        flex-grow: 2;\n        width: 100%;\n    }\n\n    &__toolbar {\n        position: relative;\n        bottom: 0;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
